/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_TrunkInputs */

const en_us2_catalog_movement_trunk = /** @type {(inputs: Catalog_Movement_TrunkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`core`)
};

const pt_br2_catalog_movement_trunk = /** @type {(inputs: Catalog_Movement_TrunkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abdômen`)
};

const es_419_catalog_movement_trunk = /** @type {(inputs: Catalog_Movement_TrunkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abdomen`)
};

const pt_pt2_catalog_movement_trunk = /** @type {(inputs: Catalog_Movement_TrunkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abdómen`)
};

const fr_fr2_catalog_movement_trunk = /** @type {(inputs: Catalog_Movement_TrunkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gainage`)
};

const de_de2_catalog_movement_trunk = /** @type {(inputs: Catalog_Movement_TrunkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rumpf`)
};

const it_it2_catalog_movement_trunk = /** @type {(inputs: Catalog_Movement_TrunkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`core`)
};

/**
* | output |
* | --- |
* | "core" |
*
* @param {Catalog_Movement_TrunkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_trunk = /** @type {((inputs?: Catalog_Movement_TrunkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_TrunkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_trunk(inputs)
	if (locale === "es-419") return es_419_catalog_movement_trunk(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_trunk(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_trunk(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_trunk(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_trunk(inputs)
	return en_us2_catalog_movement_trunk(inputs)
});
export { catalog_movement_trunk as "catalog.movement.trunk" }